import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { CredentialsService } from '../services/credentials.service';
import { AccessType } from '@shared/enums';

@Injectable({
  providedIn: 'root',
})
export class AccessGuard {
  constructor(private router: Router, private credentialsService: CredentialsService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const requiredAccessTypes: AccessType[] = route.data?.['requiredAccessTypes'];

    const hasAccess: boolean = this.credentialsService.hasAccessAny(requiredAccessTypes);

    if (!hasAccess) {
      const locationId = route.paramMap.get('locationId');
      this.router.navigate([`${locationId}/admin`]);
      return false;
    }

    return true;
  }
}
